module.exports = __webpack_public_path__ + "img/logo.358322a1.png";